import { memo } from 'react'

import AssetWithdrawalModal from '@/components/base/AssetWithdrawal/WithdrawalModal'
import { Container as TokenPickerRevampContainer } from '@/components/base/TokenPickerRevamp'
import MethodSelectionDialog from '@/components/top-coins/banner/method-selection-dialog'

import { CURRENT_TYPE, ViewProps } from './helpers'

const View = ({
  currentType,
  tokenOptions,
  onPickAToken,
  topTokensPickerSlot,
  isOpenMethodSelection,
  onCloseMethodSelection,
  onSelectMethod,
}: ViewProps) => {
  return (
    <>
      <MethodSelectionDialog
        currentType={currentType}
        isOpen={isOpenMethodSelection}
        onClose={onCloseMethodSelection}
        onClick={onSelectMethod}
      />
      <TokenPickerRevampContainer
        options={tokenOptions}
        nickName="top-coins"
        onChangeToken={onPickAToken}
        isDisplayActionView={false}
        isDisplayHighlightMessage={false}
        slot={topTokensPickerSlot}
      />

      <AssetWithdrawalModal />
    </>
  )
}

export default memo(View)
